import { updateName, updatePhoto } from '@auth/ManageUser';
import { uploadProfilePhoto } from '@db/Photos';
import { getAuthenticatedUser } from '@helpers/firebase/Auth';
import db, { setDocWithTimestamps } from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { Photo, UserFormData, UserPrivateFormData } from '@types';

type AddUserData = Pick<UserFormData, 'displayName' | 'hometown' | 'username' | 'public'>;

export async function addUser(userData: AddUserData, profilePhoto?: Photo) {
  const currentUser = getAuthenticatedUser();
  if (currentUser.displayName !== userData.displayName) {
    await updateName(currentUser, userData.displayName);
  }
  if (profilePhoto) {
    const uploadedPhoto = await uploadProfilePhoto(profilePhoto);
    await updatePhoto(currentUser, uploadedPhoto);
  }
  await addUserDoc(userData);
}

export async function addUserDoc(user: AddUserData) {
  const currentUser = getAuthenticatedUser();
  await setDocWithTimestamps(db.doc(firestore, 'users', currentUser.uid), {
    ...user,
    photoUrl: currentUser.photoURL ?? '',
  });
}

export async function addUserPrivateDoc(userPrivate: UserPrivateFormData) {
  const currentUser = getAuthenticatedUser();
  await setDocWithTimestamps(
    db.doc(firestore, 'users', currentUser.uid, 'private', currentUser.uid),
    {
      ...userPrivate,
      email: currentUser.email ?? '',
    }
  );
}
